module.exports = __webpack_public_path__ + "img/Support_the_sound.b5b71e7c.svg";